import React from 'react';
import EmptyFragment from './EmptyFragment';

export const emptyFragment = () => React.createElement(EmptyFragment, null);

export const warningFragment = (warn: string) => () => React.createElement(EmptyFragment, { warn });
